var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-bar"},[_c('cc-renderer',{staticStyle:{"margin":"0"},attrs:{"componentData":_vm.rightComponentData,"canvasStyleData":_vm.rightCanvasStyleData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }